import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Confetti from 'react-confetti';

export default function CommercialSignPage() {
    const navigate = useNavigate();
    const { id } = useParams(); // Optionnel: ID du devis/contrat
    const [signed, setSigned] = useState(false);
    const [signing, setSigning] = useState(false);
    const canvasRef = useRef(null);
    const [clientName, setClientName] = useState('');

    useEffect(() => {
        // Init canvas
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth * 0.8;
        canvas.height = 400;
        ctx.strokeStyle = '#d4af37'; // Gold
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
    }, []);

    const startDrawing = (e) => {
        setSigning(true);
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const y = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
        const rect = canvas.getBoundingClientRect();
        ctx.beginPath();
        ctx.moveTo(x - rect.left, y - rect.top);
    };

    const draw = (e) => {
        if (!signing) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const y = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
        const rect = canvas.getBoundingClientRect();

        ctx.lineTo(x - rect.left, y - rect.top);
        ctx.stroke();

        // Particules effect (simple dots)
        if (Math.random() > 0.8) {
            ctx.fillStyle = `rgba(255, 215, 0, ${Math.random()})`;
            ctx.fillRect(x - rect.left + (Math.random() * 10 - 5), y - rect.top + (Math.random() * 10 - 5), 2, 2);
        }
    };

    const stopDrawing = () => {
        setSigning(false);
    };

    const handleClear = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    const handleValidate = () => {
        if (!clientName) { alert('Veuillez entrer le nom du signataire.'); return; }
        setSigned(true);

        // Jouer un son
        const audio = new Audio('https://assets.mixkit.co/sfx/preview/mixkit-success-fanfare-trumpets-613.mp3');
        audio.volume = 0.5;
        audio.play().catch(() => { });

        setTimeout(() => {
            alert('Contrat signé et envoyé ! 🥂');
            navigate('/commercial/launchpad');
        }, 5000);
    };

    // Ajustement taille fenêtre
    useEffect(() => {
        const resize = () => {
            if (canvasRef.current) {
                canvasRef.current.width = window.innerWidth * 0.8;
                canvasRef.current.height = 400;
            }
        };
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);


    if (signed) {
        return (
            <div style={{ height: '100vh', width: '100vw', background: '#000', color: '#d4af37', display: 'grid', placeItems: 'center', fontFamily: 'serif' }}>
                <Confetti width={window.innerWidth} height={window.innerHeight} recycle={true} numberOfPieces={300} colors={['#d4af37', '#ffffff', '#fcd34d']} />
                <div style={{ textAlign: 'center', zIndex: 10, animation: 'fadeInUp 1s ease-out' }}>
                    <div style={{ fontSize: '6rem', marginBottom: 20 }}>🍾</div>
                    <h1 style={{ fontSize: '4rem', margin: 0 }}>Félicitations {clientName} !</h1>
                    <p style={{ fontSize: '1.5rem', fontFamily: 'sans-serif', opacity: 0.8, marginTop: 20 }}>Bienvenue dans la famille InfoColab.</p>
                    <p style={{ marginTop: 40, fontSize: '1rem', fontStyle: 'italic', opacity: 0.5 }}>Votre projet démarre maintenant.</p>
                </div>
                <style>{`@keyframes fadeInUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }`}</style>
            </div>
        );
    }

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif' }}>

            <div style={{ marginBottom: 20, textAlign: 'center', color: 'white' }}>
                <h1 style={{ fontSize: '2rem', fontWeight: 300, letterSpacing: 2 }}>APPROBATION DU PROJET</h1>
                <p style={{ opacity: 0.5 }}>Veuillez apposer votre signature ci-dessous</p>
            </div>

            <div style={{ width: 400, marginBottom: 20 }}>
                <input
                    type="text" placeholder="Prénom Nom (Signataire)"
                    value={clientName} onChange={e => setClientName(e.target.value)}
                    style={{ width: '100%', padding: '15px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white', borderRadius: 8, fontSize: '1.1rem', textAlign: 'center' }}
                />
            </div>

            <div style={{ position: 'relative', borderRadius: 16, overflow: 'hidden', boxShadow: '0 0 50px rgba(212, 175, 55, 0.1)', background: '#1e293b' }}>
                <canvas
                    ref={canvasRef}
                    onMouseDown={startDrawing} onMouseMove={draw} onMouseUp={stopDrawing} onMouseLeave={stopDrawing}
                    onTouchStart={startDrawing} onTouchMove={draw} onTouchEnd={stopDrawing}
                    style={{ cursor: 'crosshair', touchAction: 'none' }}
                />
                <div style={{ position: 'absolute', bottom: 20, left: 0, right: 0, textAlign: 'center', pointerEvents: 'none', opacity: 0.2, color: 'white', letterSpacing: 5 }}>ZONE DE SIGNATURE</div>
            </div>

            <div style={{ marginTop: 30, display: 'flex', gap: 20 }}>
                <button onClick={handleClear} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'white', padding: '15px 30px', borderRadius: 50, cursor: 'pointer', fontSize: '1rem' }}>Effacer</button>
                <button onClick={handleValidate} style={{ background: 'linear-gradient(135deg, #d4af37 0%, #fcd34d 100%)', border: 'none', color: 'black', padding: '15px 50px', borderRadius: 50, cursor: 'pointer', fontSize: '1.2rem', fontWeight: 700, boxShadow: '0 10px 30px rgba(212, 175, 55, 0.3)' }}>VALIDER L'ACCORD ✒️</button>
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Annuler</button>
        </div>
    );
}
